<template>
	<aside v-if="hasContent" data-component="article-takeaway-block" class="article-takeaway-block">
		<p v-if="takeawayTitle" class="article-takeaway-title">
			{{ takeawayTitle }}
		</p>
		<p v-if="takeawayText" class="article-takeaway-text">
			{{ takeawayText }}
		</p>
	</aside>
</template>

<script setup>
const props = defineProps({
	value: { type: Object, default: undefined },
	title: { type: String, default: '' },
	text: { type: String, default: '' },
})

const takeawayTitle = computed(() => props.value?.title || props.title || '')
const takeawayText = computed(() => props.value?.text || props.text || '')
const hasContent = computed(() => Boolean(takeawayTitle.value || takeawayText.value))
</script>

<style lang="scss" scoped>
[data-component='article-takeaway-block'] {
	position: relative;
	margin: rs(56, 56) 0;
	margin-bottom: rs(30, 30);
	display: flex;

	@include max-width($xs) {
		flex-direction: column;
	}

	.article-takeaway-title {
		position: absolute;
		left: calc(column-width(3, true) * -1);
		left: 0;
		transform: translateX(-100%);

		@include headline-2;
		color: var(--color-river-blue-500);
		width: column-width(4, true);

		@include max-width($xs) {
			position: relative;
			transform: none;
			margin-bottom: rs(12, 12);
			width: column-width(14, true);
		}
	}

	.article-takeaway-text {
		@include headline-4;
		color: var(--color-river-blue-900);
		width: column-width(9, true);
		white-space: pre-line;

		@include max-width($sm) {
			width: column-width(9);
		}

		@include max-width($xs) {
			width: column-width(14, true);
		}
	}
}
</style>
